import React from 'react'
import img from '../../img/dashboard-logo.cca6d925.svg'
import { RiDeleteBin5Line } from 'react-icons/ri'
import { BiUpload } from 'react-icons/bi'
import { Formik, Form } from 'formik';
import * as Yup from 'yup'


const ProfileContent = () => {


    const validate = Yup.object({
        username: Yup.string()
            .min(3),
        email: Yup.string()
            .email('Email is invalid'),
        business_name: Yup.string()
            .min(3),
        phone: Yup.string()
            .min(11),
        
    })


  return (
    <div className='profile__'>
        <div className="upload__photo__">
            <img src={img} alt="" />
            <p className='upload__desc'>Upload your photo... <br />
                Photo should be at least 300px by 300px
            </p>
            <div className="remove__upload">
                <button className='remv-upld delete__photo '><RiDeleteBin5Line/> Delete</button> 
                <button className='remv-upld  upload__photo '><BiUpload/> Upload</button>
            </div>
        </div>

        <Formik
            initialValues={{ 

                username: '',
                email: '', 
                phone: '',
                business_name: '',

            }}

            validationSchema={validate}

            onSubmit = {( values ) => {
                console.log('Form values', values)
            }}
        >

            {formik => (

                <div className="form__control">
                    <Form action="#">
                        <div className='form__flex'>
                            <div className="first__last___name">

                                <div className='first__name__container'>
                                    <label htmlFor="username">Username</label><br />
                                    <input 
                                        className='input__layer__two' 
                                        type="text" 
                                        name='username' 
                                        disabled
                                    />
                                </div>

                                <div className='last__name__container'>
                                    <label htmlFor="phone">Phone Number</label><br />
                                    <input 
                                        className='input__layer__two' 
                                        type="text" 
                                        name='phone' 
                                        disabled
                                    />
                                </div>
                            </div>
                    
                        </div>


                        <div className="email__phone">
                            <label htmlFor="email">Email Address</label>
                            <input 
                                className='input__layer__two' 
                                type="email" 
                                name='email' 
                                disabled
                            />

                            <label htmlFor="business_name">Business Name</label>
                            <input 
                                className='input__layer__two' 
                                type="text"  
                                name="business_name"
                                disabled
                            />

                            { /* <button 
                                className='__btn' 
                                type="submit"  
                            >
                                Save 
                            </button> */ }
                        </div>

                    </Form>
                </div>
                
            )}
        </Formik>
    </div>
  )
}

export default ProfileContent